import { UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/Select';
import FormInputWrapper from 'components/input/FormInputWrapper';
import { InputValue } from 'components/input/RHFTextInput';
import { Grid } from 'components/layout';
import {
  TMSTrailerNumber,
  TMSTruckNumber,
} from 'lib/api/getTruckTrailerNumbers';
import {
  LoadDateTimeInput,
  LoadTextInput,
} from 'pages/LoadView/LoadInformation/Components';
import { NormalizedLoad } from 'types/Load';
import { datetimeFieldOptions } from 'utils/formValidators';

import { LoadBuildingTextInput } from './Customer';

export function CarrierForm({
  formMethods,
  truckNumbers,
  trailerNumbers,
}: {
  formMethods: UseFormReturn<NormalizedLoad>;
  truckNumbers: TMSTruckNumber[];
  trailerNumbers: TMSTrailerNumber[];
}) {
  const { watch } = formMethods;

  const currentLoad = watch(); // Get current form values

  return (
    <>
      <LoadBuildingTextInput name='carrier.name' label='Name' readOnly={true} />
      <Grid cols='2' gap='sm' className='w-full'>
        <LoadTextInput name='carrier.mcNumber' label='MC #' readOnly />
        <LoadTextInput name='carrier.dotNumber' label='DOT #' readOnly />
      </Grid>
      <LoadTextInput name='carrier.dispatcher' label='Dispatcher' readOnly />

      <LoadTextInput
        name='carrier.firstDriverName'
        label='First Driver Name'
        readOnly
      />
      <LoadTextInput
        name='carrier.firstDriverPhone'
        label='First Driver Phone'
        inputValue={InputValue.PHONE_NUMBER}
        readOnly
      />

      <Grid cols='4' gap='sm' className='w-full'>
        <div className='col-span-3'>
          <LoadTextInput name='carrier.dispatchCity' label='City' readOnly />
        </div>

        <div className='col-span-1'>
          <LoadTextInput name='carrier.dispatchState' label='State' readOnly />
        </div>
      </Grid>

      <LoadTextInput
        name='carrier.trackingMethod'
        label='Selected Tracking Method'
        readOnly
      />
      <Grid cols='3' gap='sm' className='w-full'>
        <Controller
          name='carrier.truckNumber'
          control={formMethods.control}
          render={({ field }) => (
            <FormInputWrapper name='carrier.truckNumber' label='Truck #'>
              <Select
                onValueChange={field.onChange}
                value={field.value || ''}
                name={field.name}
              >
                <SelectTrigger className='w-full'>
                  <SelectValue placeholder='Select Truck #' />
                </SelectTrigger>
                <SelectContent>
                  {truckNumbers.length > 0 ? (
                    truckNumbers
                      .filter(
                        (t) => t.truckNumber && t.truckNumber.trim() !== ''
                      )
                      .map((t) => (
                        <SelectItem key={t.id} value={t.truckNumber}>
                          {t.truckNumber}
                        </SelectItem>
                      ))
                  ) : (
                    <SelectItem
                      value={field.value || 'no-trucks-available'}
                      disabled
                    >
                      {field.value || 'No trucks available'}
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>
            </FormInputWrapper>
          )}
        />
        <Controller
          name='carrier.trailerNumber'
          control={formMethods.control}
          render={({ field }) => (
            <FormInputWrapper name='carrier.trailerNumber' label='Trailer #'>
              <Select
                onValueChange={field.onChange}
                value={field.value || ''}
                name={field.name}
              >
                <SelectTrigger className='w-full'>
                  <SelectValue placeholder='Select Trailer #' />
                </SelectTrigger>
                <SelectContent>
                  {trailerNumbers.length > 0 ? (
                    trailerNumbers
                      .filter(
                        (t) => t.trailerNumber && t.trailerNumber.trim() !== ''
                      )
                      .map((t) => (
                        <SelectItem key={t.id} value={t.trailerNumber}>
                          {t.trailerNumber}
                        </SelectItem>
                      ))
                  ) : (
                    <SelectItem
                      value={field.value || 'no-trailer-available'}
                      disabled
                    >
                      {field.value || 'No trailers available'}
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>
            </FormInputWrapper>
          )}
        />
        <LoadTextInput name='carrier.tractorVIN' label='Tractor VIN' readOnly />
      </Grid>

      {/* <LoadTextInput name='carrier.notes' label='Notes' /> */}

      <LoadTextInput
        name='carrier.rateConfirmationSent'
        label='Rate Confirmation Sent'
        readOnly
      />
      <LoadDateTimeInput
        name='carrier.confirmationSentTime'
        label='Rate Confirmation Sent Time'
        options={datetimeFieldOptions}
        load={currentLoad}
        readOnly
      />
      <LoadTextInput
        name='carrier.signedBy'
        label='Rate Confirmation Signed By'
        readOnly
      />
    </>
  );
}
